/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Paper, } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';

import { useAppBarHeight } from '../../../common/CustomHooks';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import DatagridVoucherRegistration from '../components/DatagridVoucherRegistration';

interface IProps {
    type: "IncomingInvoice" | "OutgoingInvoice" | "Banking" | "JournalEntries" | "Miscellaneous" | "Addition" | "Cash" | "Statement",
}

const VoucherRegistration = (props: IProps): JSX.Element => {

    const { organizationId } = useParams();

    const theme = useTheme();

    //########################################################################################
    const appBarHeight = useAppBarHeight();
    //########################################################################################
    //########################################################################################
    return <main>
        <Grid container component={Paper} direction="column" wrap="nowrap"
            sx={{
                padding: theme.spacing(2),
                width: "100%",
                height: {
                    xs: "calc(100vh - " + appBarHeight + "px )",
                    xl: "calc(100vh)"
                },
            }}>
            <DatagridVoucherRegistration organizationId={organizationId ? organizationId : ""} site={props.type} />
        </Grid>
    </main>

}
export default VoucherRegistration;